import { render } from "./InvoiceTemplateDialog.vue?vue&type=template&id=56168924"
import script from "./InvoiceTemplateDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__